import React from 'react'
import { Link, Head, getRouteProps } from 'react-static'
import PropTypes from 'prop-types'

import Header from '../Header'
import BlogArchive from './BlogArchive'
import BlogContent from './BlogContent'
import ContactPanel from '../ContactPanel'
import Footer from '../Footer'
import Burger from '../Burger'
import DropdownMenu from '../DropdownMenu'

import logo from '../../images/logo-horizontal-white.png'

import '../../styles/blog/blog.scss'

class Blog extends React.Component {
  static propTypes = {
    posts: PropTypes.array,
    post: PropTypes.object,
    match: PropTypes.object,
  }

  constructor (props) {
    super(props)
    this.state = {
      burgerToggled: false,
    }
  }

  componentDidMount () {
    window.scrollTo(0, 0)
  }

  toggleBurger = () => {
    this.setState({ burgerToggled: !this.state.burgerToggled })
  }

  render () {
    const { burgerToggled } = this.state
    const { posts, post } = this.props
    return (
      <div className="blog-page">
        <Head>
          <title>Blog</title>
        </Head>
        <Header className="blog-header">
          <Link to="/">
            <img className="header__logo" src={logo} alt="Makuch Roofing Logo" />
          </Link>
          <Burger click={this.toggleBurger} toggled={burgerToggled} />
        </Header>
        <DropdownMenu active={burgerToggled}>
          <Link to="/">Home</Link>
          <Link to="/contact">Contact</Link>
        </DropdownMenu>
        <div className="blog__title">
          <h2>Blog</h2>
        </div>
        { post && posts &&
          <BlogContent
            mainPost={post}
            otherPosts={posts}
          /> }
        { posts && !post && <BlogArchive posts={posts} /> }
        {/* posts && !post &&
          <div className="blog__archive-button">
            <h5>Want to see more?</h5>
            <Link to="/blog">
              <button className="secondary-button">View Archive</button>
            </Link>
          </div> */}
        <ContactPanel isContact={false} />
        <Footer homeLink />
      </div>
    )
  }
}

export default getRouteProps(Blog)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/blog-page/Blog.js